import '../types/product.js';
import { SINGLE_PURCHASE } from '../types/purchase-types.js';

const getDisplayPrice = (activeVariant, state)=>{
    let price = activeVariant.purchaseTypePrices[state.selectedPurchaseType];
    if (!price) {
        console.error(`No price found for purchase type "${state.selectedPurchaseType}" on variant with sku: ${activeVariant.sku}`);
        // This scenario is very unlikely, but if it happens,
        // default to show the single purchase price
        price = activeVariant.purchaseTypePrices[SINGLE_PURCHASE];
    }
    return price;
};

export { getDisplayPrice };
//# sourceMappingURL=get-display-price.js.map
